// Utility function to get available encoding schemes based on VPOD count

// MORK TODO: Import this from centralized location if needed elsewhere
// Parse encoding scheme string into components
const parseEncodingScheme = (encodingScheme) => {
   
  if (!encodingScheme || typeof encodingScheme !== 'string') {
    console.warn('Invalid encoding scheme provided, defaulting to 4+2');
    encodingScheme = '4+2'; // Default value
  }
//log('EncodingScheme', encodingScheme);
  try {
    const [dataBits, parityBits] = encodingScheme.split('+').map(Number);
    
    // Validate the parsed values
    if (isNaN(dataBits) || isNaN(parityBits)) {
      console.warn('Invalid encoding scheme format, defaulting to 4+2');
      return { dataBits: 4, parityBits: 2 };
    }
    //log('dataBits', dataBits);
    //log('parityBits', parityBits);
    //log('spareBits', spareBits);

    return { dataBits, parityBits };
  } catch (error) {
    console.warn('Error parsing encoding scheme, defaulting to 4+2');
    return { dataBits: 4, parityBits: 2};
  }
  
};

// Calculate VPOD useable capacity
const calculateVpodUseableCapacity = (storageNodeConfig, encodingScheme, spareBits = 2) => {

    if (!storageNodeConfig) {
    console.error('Configuration object is required');
    return 0;
  }

  const { nodeCount, jbodSize, vpodHddCapacity, vpodSsdCapacity, vpodsPerNode, mlec } = storageNodeConfig;
  // log('storageNodeConfig', storageNodeConfig);
  
  // Add guard clause: if nodeCount is 0, return 0
  if (nodeCount === 0) {
    return 0;
  }
  
  const { dataBits, parityBits } = parseEncodingScheme(encodingScheme);
  
  // NOTE MORK - This removes overhead for Metadata from SW ssds
  function getUsableVpodSsdCapacity(vpodSsdCapacity) {
    switch (vpodSsdCapacity) {
      case 1.92:
        return 0.896;
      case 3.84:
        return 2.810;
      case 7.68:
        return 6.639;
      case 15.36:
        return 14.296;
      case 30.72:
        return 29.609;
      default:
        // Fallback to the original calculation if the value isn't one of the predefined ones.
        return vpodSsdCapacity - 1;
    }
  }
  
  // CONF-94: with MLEC, one of each VPOD's HDDs becomes local raidz1 parity, so
  // the VPOD holds one drive less of customer data. The VPOD's NVMe is a single
  // device with nothing to stripe against, so getUsableVpodSsdCapacity is
  // untouched — MLEC is an HDD-only deduction.
  //
  // Raw capacity is computed separately in hybridNodeMetrics and never sees this
  // flag, which is what keeps pricing (billed on raw TB) neutral by construction.
  const hddPerVpod = (jbodSize / vpodsPerNode) - (mlec ? 1 : 0);
  const osdRawCapacity = (vpodHddCapacity * hddPerVpod) + getUsableVpodSsdCapacity(vpodSsdCapacity);
  // log('osdRawCapacity', osdRawCapacity);

  // Calculate OSD-related metrics
  // const osdsPerJbod = jbodSize / 12;
  //log('osdsPerJbod', osdsPerJbod);
  //Note: Changed below from using 50% of vpodSSDCapacity to subtracting 1TB, this is to account for AFA versions with large SSD's.
  //log('vpodHddCapacity', vpodHddCapacity);
  //log('jbodSize', jbodSize);
  //log('vpodSsdCapacity', vpodSsdCapacity);  
  //log('osdRawCapacity', osdRawCapacity);
  // const rawUseableCapacityPerVpod =  12* osdRawCapacity;
  //log('rawUseableCapacityPerVpod', rawUseableCapacityPerVpod);
  const totalOsdCount = vpodsPerNode * nodeCount;
  // log('totalOsdCount', totalOsdCount);
  
  // Remove spare capacity OSDs
  const remainingOsds = totalOsdCount - spareBits;
  // log('remainingOsds', remainingOsds);
  
  // Calculate useable capacity using encoding ratio
  const encodingRatio = dataBits / (dataBits + parityBits);
  //log('encodingRatio', encodingRatio);
  const vpodUseableCapacity = (remainingOsds * osdRawCapacity) * encodingRatio;
  // log('vpodUseableCapacity', vpodUseableCapacity);  
  
  return vpodUseableCapacity;
};

// Calculate VeLO useable capacity
const calculateVeloUseableCapacity = (config) => {
  const { veloCount, veloSsdCapacity } = config;
  
  // Add guard clause: if veloCount is 0, return 0
  if (veloCount === 0) {
    return 0;
  }
  
  const capacityPerVelo = 0;
  //log('capacityPerVelo', capacityPerVelo);
  //log('veloCount', veloCount);
  return veloCount * capacityPerVelo;
};

// Main function to calculate total effective capacity
export const calculateTotalEffectiveCapacity = (config, encodingScheme, spareBits = 2) => {
  // Add guard clause at the top level: if nodeCount is 0, return all zeroes
  if (!config || config.nodeCount === 0) {
    return {
      totalEffectiveCapacity: 0,
      vpodUseableCapacity: 0,
      veloUseableCapacity: 0,
    };
  }
  
  // Validate encoding scheme based on VPOD count
  //const availableSchemes = getAvailableEncodingSchemes(config.vpodCount);
  //if (!availableSchemes.includes(encodingScheme)) {
  //  throw new Error(`Invalid encoding scheme ${encodingScheme} for ${config.vpodCount} VPODs. Available schemes: ${availableSchemes.join(', ')}`);
  //}
  
  // Calculate both components
  const vpodUseableCapacity = calculateVpodUseableCapacity(config, encodingScheme, spareBits);
  // const veloUseableCapacity = calculateVeloUseableCapacity(config); // MORK TODO : This is not used or displayed in the UI, investigate
  const veloUseableCapacity = 0;
  
  // Return total effective capacity
  return {
    totalEffectiveCapacity: vpodUseableCapacity + veloUseableCapacity,
    vpodUseableCapacity,
    veloUseableCapacity,
  };
};